import React, { useEffect } from "react";
import {
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemText,
    Box,
    CircularProgress,
} from "@mui/material";
import "./company.scss";
import {
    fetchCompanies,
    selectCompany,
} from "../../features/company/companyThunk";
import { useDispatch, useSelector } from "react-redux";
const Company = ({ onClose }) => {
    const dispatch = useDispatch();
    const companies = useSelector((state) => state.company.companies);
    const selectedCompany = useSelector((state) => state.company.selectedCompany);
    const loading = useSelector((state) => state.company.isLoading);
    const user = useSelector((state) => state.auth.user);
    console.log(user.role_id,"User")
    const isSuperAdmin = user?.role_id === 'SUPERADMIN';
    // Filter companies based on user role
    const displayedCompanies = React.useMemo(() => {
        if (isSuperAdmin) {
            return companies; // Show all companies for superadmin
        } else {
            // For other roles, show only their allocated company
            return companies.filter(company =>
                company.id.toString() === user?.company_id?.toString()
            );
        }
    }, [companies, isSuperAdmin, user?.company_id]);
    // Fetch companies on mount
    useEffect(() => {
        dispatch(fetchCompanies());
    }, [dispatch]);
    // Auto-select first company if none is selected or auto-select user's company if not superadmin
    useEffect(() => {
        if (displayedCompanies.length > 0) {
            if (!selectedCompany) {
                dispatch(selectCompany(displayedCompanies[0].id));
            } else if (!isSuperAdmin && user?.company_id &&
                       selectedCompany.id.toString() !== user.company_id.toString()) {
                // If not superadmin, ensure their company is selected
                const userCompany = companies.find(c => c.id.toString() === user.company_id.toString());
                if (userCompany) {
                    dispatch(selectCompany(userCompany.id));
                }
            }
        }
    }, [displayedCompanies.length, selectedCompany?.id, user?.company_id]);
    const handleCompanySelect = (companyId) => {
        dispatch(selectCompany(companyId));
        if (onClose && typeof onClose === "function") {
            onClose();
        }
    };
    return (
        <Box className="box">
            <DialogTitle
                className="title"
                sx={{ fontWeight: "bold", fontSize: "1.2rem", color: "#225CA6" }}
            >
                Seleziona azienda agricola
            </DialogTitle>
            <DialogContent className="dialogContent">
                {loading ? (
                    <CircularProgress color="primary" />
                ) : (
                    <List sx={{ color: "#225CA6" }}>
                        {displayedCompanies.length === 0 ? (
                            <ListItem>
                                <ListItemText primary="Nessuna azienda disponibile" />
                            </ListItem>
                        ) : (
                            displayedCompanies.map((comp, index) => (
                                <ListItem
                                    button
                                    key={comp.id || index}
                                    onClick={() => handleCompanySelect(comp.id)}
                                    selected={selectedCompany?.id === comp.id}
                                >
                                    <ListItemText primary={comp.name} />
                                </ListItem>
                            ))
                        )}
                    </List>
                )}
            </DialogContent>
        </Box>
    );
};
export default Company;
